enum WidgetTargetClass {
  None = '',
  Currency = 'CURRENCY',
  Percentage = 'PERCENTAGE',
  Count = 'COUNT',
}

export default WidgetTargetClass;
